import { updateCart } from '@kega/sps-core/src/reducers/cart/actions';

import isInvalidTokenError from '../auth/isInvalidTokenError';
import isCartNotFoundError from './isCartNotFoundError';

let cartValidationPromise = null;

export const waitForCartValidation = () => cartValidationPromise ?? Promise.resolve();

export const resetCartValidation = () => {
    cartValidationPromise = null;
};

const syncCartWithStore = async ({ cart, cartId, userId, dispatch }) => {
    const result = await cart.getDetails(cartId, { userId, fields: 'FULL' });
    dispatch(updateCart(result));
    return result;
};

export const trySyncCurrentCart = async ({ authenticated, cart, dispatch }) => {
    if (!authenticated) {
        return null;
    }

    try {
        return await syncCartWithStore({
            cart,
            cartId: 'current',
            userId: 'current',
            dispatch,
        });
    } catch (error) {
        if (isCartNotFoundError(error) || isInvalidTokenError(error)) {
            return null;
        }

        throw error;
    }
};

export const recoverFromStaleCart = async ({ authenticated, cart, dispatch, clearCart }) => {
    clearCart();
    return trySyncCurrentCart({ authenticated, cart, dispatch });
};

export const validatePersistedCart = async ({ getCartId, authenticated, cart, dispatch, clearCart }) => {
    const persistedCartId = getCartId();
    const userId = authenticated ? 'current' : 'anonymous';

    if (!persistedCartId) {
        return trySyncCurrentCart({ authenticated, cart, dispatch });
    }

    try {
        const cartId = userId === 'current' ? 'current' : persistedCartId;

        return await syncCartWithStore({ cart, cartId, userId, dispatch });
    } catch (error) {
        if (isInvalidTokenError(error)) {
            return null;
        }

        if (isCartNotFoundError(error)) {
            return recoverFromStaleCart({ authenticated, cart, dispatch, clearCart });
        }

        throw error;
    }
};

export const startCartValidation = (deps) => {
    if (!cartValidationPromise) {
        cartValidationPromise = validatePersistedCart(deps);
    }

    return cartValidationPromise;
};
